import { useLanguage } from "contexts/LanguageContext";
import Modal from "./Modal";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  deleteMessage: string;
  deleteWarning: string;
  danger?: boolean;
  zIndex?: number;
}

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  deleteMessage,
  deleteWarning,
  danger = false,
  zIndex
}: ConfirmDeleteModalProps) => {
  const { t } = useLanguage();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      zIndex={zIndex}
    >
      <div className="space-y-5">
        <div className="flex items-start gap-3">
          <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${danger ? 'bg-red-100 dark:bg-red-500/20 text-red-600 dark:text-red-400' : 'bg-amber-100 dark:bg-amber-500/20 text-amber-600 dark:text-amber-400'}`}>
            <ExclamationTriangleIcon className="h-5 w-5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[15px] font-medium text-gray-900 dark:text-gray-50 leading-snug">{deleteMessage}</p>
            {deleteWarning && (
              <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400 leading-snug">{deleteWarning}</p>
            )}
          </div>
        </div>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <button type="button" onClick={onClose} className="crm-btn crm-btn-secondary h-11 sm:h-9">
            {t('common.cancel')}
          </button>
          <button type="button" onClick={onConfirm} className="crm-btn crm-btn-danger h-11 sm:h-9">
            {t('common.delete')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default ConfirmDeleteModal